module.exports = __webpack_public_path__ + "img/CH_FF.91437c05.svg";